module.exports = __webpack_public_path__ + "static/media/close.77bcdf64.svg";